import { render, staticRenderFns } from "./message-monitoringandearly-warning.vue?vue&type=template&id=37fdfaf7&scoped=true&"
import script from "./message-monitoringandearly-warning.vue?vue&type=script&lang=js&"
export * from "./message-monitoringandearly-warning.vue?vue&type=script&lang=js&"
import style0 from "./message-monitoringandearly-warning.vue?vue&type=style&index=0&id=37fdfaf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fdfaf7",
  null
  
)

export default component.exports